// Single source of truth for "where should this user land after login?"
// Used by AuthCallback and LandingPage so cook/nutritionist/segment_admin/
// admin/manager/rider/chef/user all redirect consistently.
export function roleHome(role) {
  switch (role) {
    case "admin":
    case "manager":
    case "chef":
      return "/admin";
    case "rider":
      return "/admin/deliveries";
    case "segment_admin":
      return "/sa";
    case "cook":
      return "/cook";
    case "nutritionist":
      return "/admin/recipes";
    default:
      return "/home";
  }
}
